export default __webpack_public_path__ + "static/media/sendler-logo.3865ff97.svg";